import { Check } from "lucide-react"

interface Category {
  id: string
  name: string
  count: number
}

interface CategoryFilterProps {
  categories: Category[]
  selectedCategories: string[]
  onCategoryToggle: (categoryId: string) => void
}

export default function CategoryFilter({ categories, selectedCategories, onCategoryToggle }: CategoryFilterProps) {
  return (
    <div className="space-y-2">
      {categories.map((category) => (
        <div
          key={category.id}
          className="flex items-center justify-between cursor-pointer py-2.5 px-3.5 rounded-lg hover:bg-purple-100 dark:hover:bg-purple-900/30 border border-transparent hover:border-purple-200 dark:hover:border-purple-700 transition-colors duration-150"
          onClick={() => onCategoryToggle(category.id)}
        >
          <div className="flex items-center">
            <div
              className={`w-5 h-5 rounded-md border-2 flex items-center justify-center mr-3 transition-all duration-150 ${
                selectedCategories.includes(category.id)
                  ? 'bg-purple-700 border-purple-700 dark:bg-purple-600 dark:border-purple-600'
                  : 'border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800'
              }`}
            >
              {selectedCategories.includes(category.id) && (
                <Check className="h-3 w-3 text-white" />
              )}
            </div>
            <span className="text-gray-700 dark:text-gray-300 font-medium">{category.name}</span>
          </div>
          <span className="text-xs text-gray-500 bg-gray-100 dark:bg-gray-800 dark:text-gray-400 px-2 py-1 rounded-full font-medium">
            {category.count}
          </span>
        </div>
      ))}
    </div>
  )
}